import React, {useContext} from "react";
import styled from "styled-components";
import tw from "twin.macro";
import {AppContext} from "../App";

const KeyStyle = styled.div`
  margin: 1.1px;
  
  ${tw`
    flex
    w-[1.8rem]
    h-[3rem]
    text-white
    uppercase
    font-bold
    flex
    flex-row
    items-center
    justify-center
    rounded-sm
    text-base
    rounded-md
    hover:bg-gray-400
    
    sm:w-[2.1rem]
    sm:h-[3.6rem]
    sm:text-xl
    sm:font-extrabold
    md:w-[2.2rem]
    md:h-[3.6rem]
    `}
`

const KeyBig = styled.div`
  margin: 1.1px;
  
  ${tw`
    w-[2.8rem]
    h-[4em]
    text-white
    uppercase
    bg-gray-500
    font-bold
    flex
    flex-row
    items-center
    justify-center
    rounded-sm
    text-xs
    relative
    rounded-md
    hover:bg-gray-400
    
    sm:w-[3.2rem]
    sm:h-[3.6rem]
    sm:text-sm
    sm:font-bold
    md:w-[3.4rem]
    md:h-[3.6rem]
    md:text-base

    `}
`


export default function KeyButton({keyVal, disabled, error, almost, correct}) {
    const {onDelete, onSelectLetter, onEnter} = useContext(AppContext)

    const selectLetter = () => {
        if (keyVal === "Enter") {
            onEnter()
        } else if (keyVal === "Backspace") {
            onDelete()
        } else {
            onSelectLetter(keyVal)
        }
    }

    const handleWind = (error ? "bg-[#242526]" :  correct ? "bg-green-500" : almost ? "bg-yellow-500" : "bg-gray-500")

    return (
        <>
            <KeyStyle onClick={selectLetter} className={handleWind} >
                {keyVal}
            </KeyStyle>
        </>
    )
}

export function KeyEnter({keyVal}) {
    const {onDelete, onSelectLetter, onEnter} = useContext(AppContext)

    const selectLetter = () => {
        if (keyVal === "Enter") {
            onEnter()
        } else if (keyVal === "Backspace") {
            onDelete()
        } else {
            onSelectLetter(keyVal)
        }
    }

    return (
        <>
            <KeyBig onClick={selectLetter} >
                Enter
            </KeyBig>
        </>
    )
}

export function KeyDelete({keyVal}) {
    const {onDelete, onSelectLetter, onEnter} = useContext(AppContext)

    const selectLetter = () => {
        if (keyVal === "Enter") {
            onEnter()
        } else if (keyVal === "Backspace") {
            onDelete()
        } else {
            onSelectLetter(keyVal)
        }
    }

    return (
        <>
            <KeyBig onClick={selectLetter}>
                Del
            </KeyBig>
        </>
    )
}
